import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '../views/Top.vue'
import $ from 'jquery'
import { pages } from '../../vue.config.js'
console.log(pages)
Vue.use(VueRouter)
const info = require('../info.json')
const routes = [
  {
    meta: { title: pages.index.title, desc: pages.index.description },
    path: '/',
    name: 'Top',
    component: Top
  },
  {
    path: '/result1',
    name: 'result1',
    meta: { title: info['1'].title, desc: info['1'].desctiption },
    component: () => import(/* webpackChunkName: "result" */ '../views/Result.vue')
  },
  {
    meta: { title: info['2'].title, desc: info['2'].desctiption },
    path: '/result2',
    name: 'result2',
    component: () => import(/* webpackChunkName: "result" */ '../views/Result.vue')
  },
  {
    meta: { title: info['3'].title, desc: info['3'].desctiption },
    path: '/result3',
    name: 'result3',
    component: () => import(/* webpackChunkName: "result" */ '../views/Result.vue')
  },
  {
    meta: { title: info['4'].title, desc: info['4'].desctiption },
    path: '/result4',
    name: 'result4',
    component: () => import(/* webpackChunkName: "result" */ '../views/Result.vue')
  },
  {
    meta: { title: info['5'].title, desc: info['5'].desctiption },
    path: '/result5',
    name: 'result5',
    component: () => import(/* webpackChunkName: "result" */ '../views/Result.vue')
  }
]

const router = new VueRouter({
  base: '/beauties_shindan/',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: to.path === '/' ? 0 : $('#main').offset().top }
  }
})

export default router
